import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, take } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Dropdown, DropdownMenus } from './dropdowns.model';
import { ApiService } from '../api/api.service';
import handleError from 'src/app/helpers/error-handler.helper';
import { ErrorMessageService } from '../error-message/error-message.service';

@Injectable({
  providedIn: 'root',
})
export class DropdownsService {
  dropdownMenus = new BehaviorSubject<DropdownMenus | null>(null);
  loading = new BehaviorSubject<boolean>(false);

  constructor(
    private api: ApiService,
    private http: HttpClient,
    private errorMessageService: ErrorMessageService
  ) {}

  /**
   * GET request to get all dropdowns related to this application.
   */
  getDropdowns() {
    const endpoint = `${this.api.baseUrl}loan`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    this.loading.next(true);
    this.errorMessageService.clearErrorMessages();

    this.http
      .get<DropdownMenus>(endpoint, {
        headers,
      })
      .pipe(
        take(1),
        map((dropdowns: DropdownMenus) => {
          // Remove the empty value from the locations dropdown menu.
          const menus: DropdownMenus = {
            ...dropdowns,
            locations: dropdowns.locations.filter(
              (item: Dropdown) => item.Value !== ''
            ),
          };

          return menus;
        }),
        catchError(handleError)
      )
      .subscribe({
        next: (dropdownMenus: DropdownMenus) => {
          this.loading.next(false);
          this.dropdownMenus.next(dropdownMenus);
        },
        error: (error: any) => {
          this.loading.next(false);
          this.errorMessageService.addToErrorMessages(error.message);
        },
      });
  }
}
